import { candidateProvider } from './../../store/providers/candidateProvider';
import { basicDetailsProvider } from './../../store/providers/basicDetailsProvider';
import { updateSessionStorageForLoggedinUser } from './../../authentication/utils/updateSessionStorage';
import { reValidateSession } from './../../authentication/utils/revalidateSession';
import { registerAssessmentTCPlus } from './../../common/utils/registerAssessmentTCPlus';
import { Template } from '../../store/interfaces';
import { redirectUrlOnAuthentication } from './../../common/utils/redirectUrlOnAuthentication';
import { routeMappings } from './../../constants/routeMappings';
import { User } from '../../store/interfaces/user';
import { WorkflowSession } from '../../store/interfaces/workflowSession';
import { getStore } from '../../store';

export const handleRegisterAssessmentForTCPlus = async (
  candidate: User,
  workflowSession: WorkflowSession,
  resetIndicator?: boolean,
): Promise<{ url: string; error: string }> => {
  const companySettings = getStore()?.state?.companySettings;
  const simplifiedFormFlow = companySettings?.showSimplifiedForm;

  if (!workflowSession.candidateRegistered && !simplifiedFormFlow) {
    const registerData = await registerAssessmentTCPlus(candidate, workflowSession, resetIndicator);
    switch (registerData.status) {
      case 0:
        break;

      case 200:
        await reValidateSession();
        break;

      default:
        if (registerData.customResponseCode && registerData.customResponseCode === 1002) {
          return { url: routeMappings['RE_ATTEMPT'], error: registerData.message };
        }

        return { url: '', error: registerData.message };
    }
  }

  return { url: '', error: '' };
};

export const loginSuccessHandler = async (
  template: Template,
  candidate: User,
  workflowSession: WorkflowSession,
  candidateDeadlineDate?: string,
): Promise<{ url: string; error: string }> => {
  let data = { url: '', error: '' };

  const { setCandidate } = candidateProvider();
  const { updateUserSessionActive } = basicDetailsProvider();

  if (candidate) setCandidate(candidate);

  /** update sessionStorage */
  updateUserSessionActive(true);
  updateSessionStorageForLoggedinUser(candidateDeadlineDate);

  /** revalidate session, then navigate to current workflow item */
  const reValidateSessionObj = await reValidateSession();
  const { url, error } = await handleRegisterAssessmentForTCPlus(candidate, workflowSession);
  if (url || error) return { url, error };

  if (reValidateSessionObj.data && !reValidateSessionObj.error) {
    const url = await redirectUrlOnAuthentication(reValidateSessionObj.data, {
      template,
      candidate: candidate,
    });
    if (url) {
      data = { url, error: '' };
      return data;
    }
  } else {
    data = { url: '', error: 'genericError' };
    return data;
  }

  return data;
};
